import { getSafeSessionStorage } from '../../../../../helpers/browser'

const sessionStorage = getSafeSessionStorage()

/**
 * Create a namespaced key for a listing ID
 * @param {string} listingId - The listing ID
 * @returns {string} The namespaced key
 */
export const createSeenListingKey = (listingId: string): string => `listing:seen:${listingId}`

/**
 * Check if a listing ID exists in sessionStorage
 * @param {string} listingId - The listing ID to check
 * @returns {boolean} True if the listing has been seen
 */
export const isListingSeen = (listingId: string): boolean => {
  try {
    const key = createSeenListingKey(listingId)
    const value = sessionStorage.getItem(key)
    return value === 'true'
  } catch (error) {
    console.warn(`Failed to get seen listing id: ${listingId} from sessionStorage:`, error)
    return false
  }
}

/**
 * Mark a listing as seen in sessionStorage
 * @param {string} listingId - The listing ID to mark as seen
 */
export const markListingAsSeen = (listingId: string): void => {
  try {
    const key = createSeenListingKey(listingId)
    sessionStorage.setItem(key, 'true')
  } catch (error) {
    console.warn('Failed to mark listing as seen in sessionStorage:', error)
  }
}
